// Tuning knobs for the client-side learned aesthetic score (pipeline Stage 4).
//
// The MobileNetV3 regressor is converted to a TF.js GraphModel and vendored
// under public/models/aesthetic/ alongside the MediaPipe assets (see its
// README for the exact tensorflowjs_converter command). Model + calibration
// are static assets — never webpack-bundled. Inference runs in a Web Worker
// (public/aesthetic.worker.js) so it never blocks the main thread.

export const MODEL_PATH = '/models/aesthetic/model.json';
export const CALIB_PATH = '/models/aesthetic/calibration.json';

// The inference worker. All TF.js work — model load, the ~3s first-inference
// shader compile, and every scan — runs there, off the main thread.
// MODEL_PATH / MODEL_CACHE_KEY are duplicated inside the worker (a classic
// worker can't import this ES module).
export const WORKER_PATH = '/aesthetic.worker.js';

// IndexedDB key for the parsed GraphModel — TF.js caches weights here after
// the first network fetch so repeat scans skip the download (used by worker).
export const MODEL_CACHE_KEY = 'indexeddb://mogged-aesthetic';

// The model's frozen IO contract (IO_CONTRACT.json): [1,224,224,3] float32,
// 0..1, RGB. Backbone preprocessing is baked into the graph, so the only
// host-side step is divide-by-255 — matching the Colab reference (crop/255.0).
export const INPUT_SIZE = 224;

// Worker init (model download + load + warm-up) budget. On timeout warm
// resolves false and the scan proceeds Gemini-only rather than blocking.
export const MODEL_LOAD_TIMEOUT_MS = 15000;

// Per-scan inference budget once the worker is ready. On timeout the score
// resolves null (no percentile) rather than hanging the scan.
export const SCORE_TIMEOUT_MS = 8000;
